<script>
import api from '@/command/api'
import apiTool from '@/command/apiTool'
import DrawerForm from '../../../components/DrawerForm'
import TemplateHeaderTable from '../../../components/TemplateHeaderTable'
import { getAction } from '@/command/netTool'
import moment from 'moment'

export default {
  name: 'activePage',
  data() {
    return {
      ...api.command.getState(),
    }
  },
  mounted() {
    api.command.getList.call(this, {
      url: '/farmHotZoneConfig/page',
      current: 1,
    })
  },
  methods: {
    getHeader() {
      return [
        {
          name: '活动名称',
          key: 'name',
          type: 'input',
        },
        {
          label: '',
          type: 'text',
        },
      ]
    },
    getColumns() {
      return [
        {
          dataIndex: 'id',
          title: 'ID',
          align: 'left',
          sorter: (a, b) => a.id - b.id,
        },
        {
          dataIndex: 'name',
          title: '活动名称',
          align: 'left',
          customRender: (text, records) => {
            return (
              <div class="product-order-item-copy">
                {records.imgUrl ? <img src={records.imgUrl.split(',')[0]} /> : ''}
                <div>
                  <Tooltip title={text}>{text}</Tooltip>
                </div>
              </div>
            )
          },
        },

        {
          dataIndex: 'startTime',
          title: '活动时间',
          align: 'left',
          customRender: function (text, records, index, h) {
            return `${moment(records.startTime).format('YYYY/MM/DD')} - ${moment(records.endTime).format('YYYY/MM/DD')}`
          },
        },
        {
          dataIndex: 'updateTime',
          title: '更新时间',
          align: 'left',
          customRender: function (text, records, index, h) {
            return text || records.createTime
          },
        },
        {
          dataIndex: 'action',
          title: '操作',
          type: 'buttonGroup',
          align: 'center',
          width: '10%',
          typeData: ({ records }) => {
            return [
              {
                display: true,
                name: '编辑',
                onClick: () => {
                  this.$router.push(`/marketingCenter/activePage/detail?id=${records.id}`)
                },
              },
              {
                name: '删除',
                type: 'pop',
                display: true,
                popTitle: '确认是否删除吗?',
                onClick: () => {
                  api.command.del.call(this, {
                    url: '/farmHotZoneConfig',
                    params: {
                      id: records.id,
                    },
                  })
                },
              },
            ].filter((e) => e.display)
          },
        },
      ]
    },

    getButton() {
      return [
        {
          name: '添加',
          type: 'primary',
          icon: 'plus',
          onClick: () => {
            debugger
            this.$router.push('/marketingCenter/activePage/detail')
          },
        },
      ]
    },
  },
  render() {
    return (
      <TemplateHeaderTable
        headerData={this.getHeader()}
        tableColumns={this.getColumns()}
        button={this.getButton()}
        records={this.records}
      />
    )
  },
}
</script>
